import { render, staticRenderFns } from "./BusinessCards.vue?vue&type=template&id=72dafe4f&scoped=true&"
import script from "./BusinessCards.vue?vue&type=script&lang=js&"
export * from "./BusinessCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dafe4f",
  null
  
)

export default component.exports